import DatabaseModel from './DatabaseModel.js';

var AiContextRelationships = Object.create(DatabaseModel);

AiContextRelationships.model = 'ai/agent/context/relationships';
AiContextRelationships.modelFront = 'ai/agent/context/relationships';

export default AiContextRelationships;
